export function getSubdomain(): string {
  let subdomain = window.location.host.split('.')[0];

  if (/:[0-9]/gi.test(subdomain)) {
    if (process.env.REACT_APP_ASSETS_URL &&
      !subdomain.startsWith('localhost')) {
      const temp = process.env.REACT_APP_ASSETS_URL.split('.')[0];
      subdomain = temp.split('://')[1];
    } else subdomain = 'signup';
  }

  return subdomain;
}
